import React from 'react';

import { Button } from '@mui/material';

import { getProductDemoRuntimeUserId } from '~modules/product-demo/product-demo-runtime';
import { productDemoStorage } from '~modules/product-demo/product-demo-storage';

import { openConfirmationModal } from '~system/store/modal/modal-slice';
import { dispatchStoreAction } from '~system/store/store-accessor';

import { AppIcon } from '~components/shared/app-icon/app-icon';

import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconDashboard } from '../../assets/icons/icon-dashboard.svg';
import { ReactComponent as IconShow } from '../../assets/icons/icon-show.svg';

type OpenProductDemoBlockedModalOptions = {
  onSetupClick?: () => void;
};

const setupAccount = () => {
  productDemoStorage.disable(getProductDemoRuntimeUserId());

  if (typeof window !== 'undefined') {
    window.location.assign(ROUTES.ONBOARDING);
  }
};

export const openProductDemoBlockedModal = ({
  onSetupClick = setupAccount,
}: OpenProductDemoBlockedModalOptions = {}) => {
  dispatchStoreAction(
    openConfirmationModal({
      type: 'default',
      title: 'Це демо-режим',
      content:
        'У демо можна переглядати, як працює Rentify, але зміни не зберігаються. Щоб додати свою квартиру та орендаря, налаштуйте особистий кабінет.',
      actionsDirection: 'column',
      confirmButton: React.createElement(
        Button,
        {
          fullWidth: true,
          startIcon: React.createElement(AppIcon, {
            component: IconDashboard,
            size: 20,
          }),
          sx: { justifyContent: 'center' },
        },
        'Налаштувати кабінет',
      ),
      cancelButton: React.createElement(
        Button,
        {
          fullWidth: true,
          variant: 'outlined',
          startIcon: React.createElement(AppIcon, {
            component: IconShow,
            size: 20,
          }),
          sx: { justifyContent: 'center' },
        },
        'Продовжити перегляд демо',
      ),
      onConfirm: onSetupClick,
    }),
  );
};
